import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { AppDispatch } from '../store';
import { AdminReducer } from './interfaces/AdminReducer';

const initialState: AdminReducer = {
  isLogged: false,
  loginData: {
    user: undefined,
  },
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    doLogin: (state, action: PayloadAction<AdminReducer>) => {
      state.isLogged = action.payload.isLogged;
      state.loginData = action.payload.loginData;
    },
    logout: state => {
      state.isLogged = initialState.isLogged;
      state.loginData = initialState.loginData;
    },
  },
});

export const doLogin = (dispatch: AppDispatch, payload: AdminReducer) => {
  dispatch(adminSlice.actions.doLogin(payload));
};

export const logout = (dispatch: AppDispatch) => {
  dispatch(adminSlice.actions.logout());
};

const adminReducer = adminSlice.reducer;
export default adminReducer;
